module.exports = __webpack_public_path__ + "img/1F612.8fd09bd3.svg";